// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"00faae2d","191":"81eab722","255":"ea68566c","283":"0b697f38","520":"e9707383","538":"835917fc","566":"a9afc7cc","569":"c4d2228a","614":"084c75c7","676":"29d3564b","730":"7943af5d","923":"715f073c","978":"72a4a859"}[chunkId] + ".chunk.js";
};